require('./bootstrap');

import Vue from 'vue';
Vue.mixin({ methods: { route } });

import { InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue';
import PortalVue from 'portal-vue';
Vue.use(InertiaPlugin);
Vue.use(PortalVue);

import { InertiaProgress } from '@inertiajs/progress'
InertiaProgress.init({
  delay: 250,
  color: '#2563EB',
  includeCSS: true,
  showSpinner: false,
})

import mixins from './mixins'
Vue.mixin(mixins)

const req = require.context('./BaseComponents/', true, /\.(js|vue)$/i)
req.keys().map(key => {
  const name = key.match(/\w+/)[0]
  return Vue.component(name, req(key).default)
})

const app = document.getElementById('app');
new Vue({
    render: (h) =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: (name) => import(`./Pages/${name}`).then(module => module.default),
            },
        }),
}).$mount(app);
